import type { Context } from 'react';
import { createContext, useContext } from 'react';

export interface ThreadIconOptions {
  readonly commandBarBasicIcons: Partial<CommandBarBasicIcons>;
  readonly overflowIcons: Partial<OverflowIcons>;
}

export interface CommandBarBasicIcons {
  readonly like: 'Like';
  readonly comment: 'Message';
  readonly reply: 'Message' | 'Reply';
  readonly share: 'Share';
  readonly love: 'Heart';
}

export interface OverflowIcons {
  readonly edit: 'EditNote';
  readonly delete: 'Delete';
  readonly pin: 'Pinned';
  readonly unpin: 'Unpin';
  readonly close: 'MuteChat';
  readonly closeVote: 'PollResults';
  readonly reopen: 'Message';
  readonly hide: 'Hide3';
  readonly archive: 'Archive';
  readonly overflowMenu: 'MoreVertical';
}

const commandBarBasicIcons: CommandBarBasicIcons = {
  like: 'Like',
  comment: 'Message',
  reply: 'Message',
  share: 'Share',
  love: 'Heart',
};

const overflowIcons: OverflowIcons = {
  edit: 'EditNote',
  delete: 'Delete',
  pin: 'Pinned',
  unpin: 'Unpin',
  close: 'MuteChat',
  closeVote: 'PollResults',
  reopen: 'Message',
  hide: 'Hide3',
  archive: 'Archive',
  overflowMenu: 'MoreVertical',
};

export const defaultOptions: ThreadIconOptions = {
  commandBarBasicIcons,
  overflowIcons,
};

export const ThreadIconContext: Context<ThreadIconOptions> = createContext(defaultOptions);

export type UseThreadIconOptions = () => ThreadIconOptions;
export const useThreadIconOptions: UseThreadIconOptions = () => useContext(ThreadIconContext);
